import { FORUM, TRANSITION } from "./styles";

export const components = {
  components: {
    Modal: {
      baseStyle: {
        dialog: {
          bg: FORUM.panel,
          color: FORUM.tekst,
          borderRadius: "lg",
          border: "1px solid",
          borderColor: FORUM.obramowanie,
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.6)",
        },
        overlay: {
          bg: "rgba(0, 0, 0, 0.72)",
        },
        header: {
          fontFamily: "Inter, sans-serif",
          fontWeight: "600",
          fontSize: "lg",
          color: FORUM.tekstJasny,
          borderBottom: "1px solid",
          borderColor: FORUM.obramowanie,
          px: 6,
          py: 4,
        },
        body: { px: 6, py: 5 },
        footer: {
          borderTop: "1px solid",
          borderColor: FORUM.obramowanie,
          px: 6,
          py: 4,
        },
        closeButton: {
          color: FORUM.tekstPrzygaszony,
          borderRadius: "md",
          transition: TRANSITION,
          _hover: { color: FORUM.tekstJasny, bg: FORUM.plakietka },
        },
      },
    },

    Input: {
      variants: {
        outline: {
          field: {
            bg: FORUM.tlo,
            borderColor: FORUM.obramowanie,
            color: FORUM.tekst,
            borderRadius: "md",
            transition: TRANSITION,
            _placeholder: { color: FORUM.tekstPrzygaszony },
            _hover: { borderColor: "rgba(255,255,255,0.14)" },
            _focus: {
              borderColor: "#6C99FF",
              boxShadow: "0 0 0 1px #6C99FF",
            },
          },
        },
      },
      defaultProps: { variant: "outline" },
    },

    Textarea: {
      variants: {
        outline: {
          bg: FORUM.tlo,
          borderColor: FORUM.obramowanie,
          color: FORUM.tekst,
          borderRadius: "md",
          transition: TRANSITION,
          _placeholder: { color: FORUM.tekstPrzygaszony },
          _hover: { borderColor: "rgba(255,255,255,0.14)" },
          _focus: { borderColor: "#6C99FF", boxShadow: "0 0 0 1px #6C99FF" },
        },
      },
      defaultProps: { variant: "outline" },
    },

    Select: {
      variants: {
        outline: {
          field: {
            bg: FORUM.tlo,
            borderColor: FORUM.obramowanie,
            color: FORUM.tekst,
            borderRadius: "md",
            transition: TRANSITION,
            _hover: { borderColor: "rgba(255,255,255,0.14)" },
            _focus: { borderColor: "#6C99FF", boxShadow: "0 0 0 1px #6C99FF" },
            "& option": { bg: FORUM.panel, color: FORUM.tekst },
          },
          icon: { color: FORUM.tekstPrzygaszony },
        },
      },
      defaultProps: { variant: "outline" },
    },

    FormLabel: {
      baseStyle: {
        color: FORUM.tekstPrzygaszony,
        fontSize: "sm",
        fontWeight: "500",
        mb: 1.5,
      },
    },

    Button: {
      baseStyle: {
        borderRadius: "md",
        fontWeight: "500",
        transition: TRANSITION,
      },
      variants: {
        glowny: {
          bg: FORUM.granat,
          color: FORUM.tekstJasny,
          _hover: { bg: "#3A4870", transform: "translateY(-1px)" },
          _active: { bg: FORUM.granat },
        },
        drugorzedny: {
          bg: FORUM.przycisk,
          color: FORUM.tekst,
          _hover: { bg: FORUM.plakietka, color: FORUM.tekstJasny },
        },
        niszczacy: {
          bg: "transparent",
          color: "#E06C6C",
          border: "1px solid",
          borderColor: "rgba(197, 48, 48, 0.45)",
          _hover: { bg: "rgba(197, 48, 48, 0.14)", color: "#F08A80" },
        },
      },
    },
  },
};
